// extracted by mini-css-extract-plugin
export default {"root":"R93eSawM","messages":"GTEUhFtv","hidden":"c0J_1odF","spacer":"t7TzuZJa","scrollToBottom":"b7467bfe","dateSeparator":"AHaCJQ42"};